import { Lock } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { SecurityBadge } from '@/components/checkout/SecurityBadge'

export default function CheckoutFooter() {
  const { t } = useTranslation()
  const currentYear = new Date().getFullYear()

  return (
    <footer className="mt-auto border-t border-border/20 bg-background/70 backdrop-blur-sm">
      <div className="w-full max-w-6xl mx-auto px-4 py-2 sm:px-6 lg:px-8">
        <SecurityBadge />
        <div className="flex flex-col items-center justify-between gap-2 border-t border-border/20 pt-3 text-center sm:flex-row sm:text-left">
          <div className="flex items-center gap-1.5 text-muted-foreground/50">
            <Lock className="w-3 h-3" />
            <span className="text-[11px] font-medium">
              {t('footer.securedBy')}{' '}
              <span className="font-bold bg-gradient-to-r from-[#500B4D] to-[#DC2A4A] bg-clip-text text-transparent">
                Ikawaari
              </span>
            </span>
          </div>
          <p className="text-[11px] text-muted-foreground/40">
            {t('footer.copyright', { year: currentYear })}
          </p>
        </div>
      </div>
    </footer>
  )
}
